/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S1_P1Inputs */

const en_guide_json_rest_api_s1_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When sending data to an API (POST, PUT, PATCH requests), you include JSON in the request body and set the <code>Content-Type</code> header to <code>application/json</code>. This tells the server how to parse the incoming data.`)
};

const ko_guide_json_rest_api_s1_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API에 데이터를 보낼 때(POST, PUT, PATCH 요청) 요청 본문에 JSON을 포함하고 <code>Content-Type</code> 헤더를 <code>application/json</code>으로 설정합니다. 이것은 서버에 들어오는 데이터를 어떻게 파싱할지 알려줍니다.`)
};

const ja_guide_json_rest_api_s1_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIにデータを送信する際（POST、PUT、PATCHリクエスト）、リクエストボディにJSONを含め、<code>Content-Type</code>ヘッダーを<code>application/json</code>に設定します。これにより、サーバーは受信データの解析方法を認識します。`)
};

/**
* | output |
* | --- |
* | "When sending data to an API (POST, PUT, PATCH requests), you include JSON in the request body and set the <code>Content-Type</code> header to <code>applicati..." |
*
* @param {Guide_Json_Rest_Api_S1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s1_p1 = /** @type {((inputs?: Guide_Json_Rest_Api_S1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s1_p1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s1_p1(inputs)
	return ja_guide_json_rest_api_s1_p1(inputs)
});